import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import './ClientCompanies.scss'
import useWindowWidth from 'app_hooks/useWindowWidth'
import Slider from 'react-slick'
import { ILanding, TypeSlugLanding } from 'app_types/admin/landings/landingTypes'
import LandingService from 'app_services/admin/landings/landingService'
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper'

const MOVIL_CARD_WIDTH = 110
const CARD_WIDTH = 220
const MOVIL_BREAKPOINT = 760
const INTERVAL = 5000

interface IClientCompaniesProps {
  slug: TypeSlugLanding
}

const ClientCompanies: FC<IClientCompaniesProps> = ({
  slug
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [landing, setLanding] = useState<ILanding>()
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  const getNumberItems = () => {
    const widthCard = isMovil ? MOVIL_CARD_WIDTH : CARD_WIDTH
    const totalItems = Math.round((windowWidth - 80) / widthCard)
    return totalItems
  }

  const fetchData = useCallback(async () => {
    const landingService = new LandingService()
    let httpParams: any = {
      slug,
    }
    setIsLoading(true)
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      setLanding(landingResponse)
    }
    setIsLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const itemsToRender = useMemo(() => landing?.landing?.our_clients, [landing])

  if (!itemsToRender?.length) return null

  return (
    <div className='client-companies--container'>
      <LoadingWrapper loading={isLoading}>
        <Slider
          arrows={false}
          autoplay
          autoplaySpeed={INTERVAL}
          className='slider-page'
          infinite={(itemsToRender?.length >= getNumberItems()) ? true : false}
          slidesToShow={getNumberItems()}
        >
          {itemsToRender.map(({ url, title }, idx) => (
            <div key={idx} style={{ width: CARD_WIDTH }}>
              <div className="client-companies--image-container">
                <img src={url} alt={`Imagen del cliente ${title}`}/>
              </div>
            </div>
          ))}
        </Slider>
      </LoadingWrapper>
    </div>
  )
}

export default ClientCompanies
